import BaseModel from "@/api/models/BaseModel";

/**
 * PaymentMethodDictionary
 */
export default class PaymentMethodDictionary extends BaseModel {
    
    constructor() {
        super();

        this.ACCOUNT_MONEY = 'account_money';
        this.PIX = 'pix';
        this.CREDIT_CARD = 'credit_card';
        this.DEBIT_CARD = 'debit_card';
        this.TICKET = 'ticket';
        this.BANK_TRANSFER = 'bank_transfer';
        this.DIGITAL_CURRENCY = 'digital_currency';
    }

    /**
     * Retorna o label amigável baseado no ID ou no Type do Mercado Pago
     * @param {string} key 
     * @returns {string}
     */
    getLabel(key) {
        const labels = {
            [this.ACCOUNT_MONEY]: 'Saldo Mercado Pago',
            [this.PIX]: 'Pix',
            [this.CREDIT_CARD]: 'Cartão de Crédito',
            [this.DEBIT_CARD]: 'Cartão de Débito',
            [this.TICKET]: 'Boleto',
            [this.BANK_TRANSFER]: 'Transferência Bancária',
            [this.DIGITAL_CURRENCY]: 'Mercado Crédito'
        };

        return labels[key] || key || 'Não identificado';
    }

    /**
     * Método auxiliar para resolver o label a partir do objeto payment_method do payload
     * @param {Object} paymentMethodObject 
     */
    getLabelFromPayload(paymentMethodObject) {
        if (!paymentMethodObject) {
            return 'Não identificado';
        }

        const idLabel = this.getLabel(paymentMethodObject.id);
        if (idLabel !== paymentMethodObject.id) {
            return idLabel;
        }

        return this.getLabel(paymentMethodObject.type);
    }
}